import React, { useEffect, useState } from 'react';
import { Button } from '../../components/ui/button';
import { HomlyLogo } from '../../components/brand/HomlyLogo';

const DISPLAY = { fontFamily: "'Space Grotesk', sans-serif" };

/**
 * ConvNav — Sticky glass navigation for the conversion landing.
 * Contains only the logo + a single "Demander une démo" CTA (zero distraction).
 */
export const ConvNav = ({ onDemoClick }) => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <nav
            data-testid="landing-sticky-nav"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
                scrolled
                    ? 'bg-[#050308]/80 backdrop-blur-xl border-b border-white/[0.08]'
                    : 'bg-transparent border-b border-transparent'
            }`}
            style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
        >
            <div className="max-w-6xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
                <a
                    href="/"
                    data-testid="landing-logo"
                    className="inline-flex items-center transition-opacity hover:opacity-90"
                >
                    <HomlyLogo size="lg" />
                </a>
                <div className="flex items-center gap-4 sm:gap-6">
                    <a
                        href="/recherche"
                        data-testid="nav-recherche-link"
                        className="hidden sm:inline-flex text-sm font-medium text-[#A19DAB] hover:text-white transition-colors"
                    >
                        Trouver un agent
                    </a>
                    <a
                        href="/login"
                        data-testid="nav-login-link"
                        className="text-sm font-medium text-[#A19DAB] hover:text-white transition-colors"
                    >
                        Connexion
                    </a>
                    <Button
                        onClick={onDemoClick}
                        data-testid="sticky-nav-demo-button"
                        className="bg-gradient-to-r from-[#681793] to-[#FF914D] hover:opacity-90 text-white font-semibold text-sm px-4 sm:px-6 h-10 rounded-full shadow-lg shadow-[#681793]/30 transition-opacity"
                    >
                        Demander une démo
                    </Button>
                </div>
            </div>
        </nav>
    );
};
